// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RGgTW","comment":"styles_comment__32Rga"};